import { render, staticRenderFns } from "./ReturnLocations.vue?vue&type=template&id=078427c6&"
import script from "./ReturnLocations.vue?vue&type=script&lang=js&"
export * from "./ReturnLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports